import { useGetScheduledPendingServiceQuery } from '../services/scheduled-pending.service';

interface UseGetScheduledPendingProps {
  filters: any;
  paginated: {
    page: number;
    pageSize: number;
  };
}

const useGetScheduledPending = ({
  filters,
  paginated,
}: UseGetScheduledPendingProps) => {
  const { data: schedulePending, isLoading } =
    useGetScheduledPendingServiceQuery({
      filters,
      paginated,
    });

  return {
    isLoading,
    schedulePending: schedulePending?.items || [],
    totalItems: schedulePending?.count || [].length,
    totalPages: schedulePending?.count
      ? Math.ceil(schedulePending.count / paginated.pageSize)
      : 0,
  };
};

export default useGetScheduledPending;
